import React, { useEffect, useState } from "react";
import { fetchPublicationsDatabase } from "../../services/nocodb";
import sortByDate from "./../../helpers/sortByDate";

import ListItem from "./ListItem";

const CACHE_KEY = "cachedPublications";
const CACHE_EXPIRY_MS = 1000 * 60 * 60; // 1 hour

function List() {
  const [publications, setPublications] = useState();
  const [reload, setReload] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getPublications();
  }, [reload]);

  async function getPublications() {
    const cached = localStorage.getItem(CACHE_KEY);
    const cachedTime = localStorage.getItem(`${CACHE_KEY}_timestamp`);
    const now = Date.now();
    const isCacheValid = cached && cachedTime && now - cachedTime < CACHE_EXPIRY_MS;

    if (isCacheValid) {
      try {
        const cachedData = JSON.parse(cached);
        sortByDate(cachedData);
        setPublications(cachedData);
        setLoading(false);
        return;
      } catch (e) {
        console.warn("Corrupted publications cache, refetching...");
      }
    }

    try {
      const data = await fetchPublicationsDatabase();
      sortByDate(data);
      setPublications(data);
      localStorage.setItem(CACHE_KEY, JSON.stringify(data));
      localStorage.setItem(`${CACHE_KEY}_timestamp`, now.toString());
    } catch (err) {
      console.error("Error loading data from NocoDB", err);
    } finally {
      setLoading(false);
    }
  }

  if (loading) return <div className={"loader"}></div>;

  return (
    <div className="row">
      {
        publications &&
        publications.map(publication =>
          <ListItem
            key={publication.Id}
            publication={publication}
            setReload={setReload}
          />
        )
      }
    </div>
  );
}

export default List;